import api from 'api'

export function updateDob(userId: string, dob: string) {
  return api.put(`/admin/user/${userId}/dob`, { dob })
}
